import React from "react";
import * as APIUtils from "../api/api-utils";
import * as JourneyAPI from "../api/journey-api";
import { RouteComponentProps, Redirect } from "react-router-dom";
import HeaderNavBar from "../components/HeaderNavBar";
import JourneyTile from "../components/JourneyTile";
import ThresholdExplaination from "../components/ThresholdExplain";
import SearchResultHeader from "../components/SearchResultHeader";
import { LocationDescriptor } from "history";
import { StaticContext } from "react-router";
import AppNavigationState from "../utils/AppNavigationState";
import { StationDefinition, Journey } from "../api/api-data-model";
import LoadingSpinner from "../components/LoadingSpinner";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";

type RouterParams = { from: string; to: string; datetime: string };

interface ISearchJourneyResultPageProps
  extends WithTranslationLangProps,
    RouteComponentProps<
      RouterParams,
      StaticContext,
      AppNavigationState | undefined
    > {}

interface ISearchJourneyResultPageState {
  isLoadingJourneys: boolean;
  journeysData?: JourneyAPI.GetJourneysResult;
  searchDate: Date;
  from?: StationDefinition;
  to?: StationDefinition;
  redirect?: LocationDescriptor<AppNavigationState>;
}

class SearchJourneyResultPage extends React.Component<
  ISearchJourneyResultPageProps,
  ISearchJourneyResultPageState
> {
  constructor(props: ISearchJourneyResultPageProps) {
    super(props);
    this.state = {
      isLoadingJourneys: true,
      searchDate: APIUtils.dateFromAPIString(this.props.match.params.datetime),
      from: props.location.state?.searchContext?.fromStation,
      to: props.location.state?.searchContext?.toStation,
    };
    this.getJourneyTiles = this.getJourneyTiles.bind(this);
    this.handleAnalyseClicked = this.handleAnalyseClicked.bind(this);
    this.handleJourneyClicked = this.handleJourneyClicked.bind(this);
  }

  componentDidMount() {
    JourneyAPI.getJourneys(
      this.props.match.params.from,
      this.props.match.params.to,
      this.state.searchDate
    )
      .then((result) => {
        this.setState({
          isLoadingJourneys: false,
          journeysData: result,
          from: result.query.from,
          to: result.query.to,
        });
      })
      .catch((_) => {
        this.setState({
          isLoadingJourneys: false,
        });
      });
  }

  private getJourneyTiles() {
    if (
      this.state.journeysData === undefined ||
      this.state.journeysData?.journeys.length === 0
    )
      return <div>{this.props.t("no_trains")}</div>;

    if (this.state.journeysData) {
      let from = this.state.journeysData.query.from;
      let to = this.state.journeysData.query.to;
      return [
        <ThresholdExplaination
          delay_threshold = {this.state.journeysData.delay_threshold}
          i18nKey={this.props.t("threshold_journey_result")}
        />,
        this.state.journeysData.journeys.map((journey) => {
        return (
          <JourneyTile
            key={journey.id}
            journey={journey}
            startStation={from}
            endStation={to}
            onClick={this.handleJourneyClicked}
          />
        );
      })];
    } else return undefined;
  }

  private handleAnalyseClicked() {
    let from = this.props.match.params.from;
    let to = this.props.match.params.to;

    let stateObject: AppNavigationState = {
      searchContext: {
        fromStation: this.state.from,
        toStation: this.state.to,
        searchDate: this.state.searchDate,
      },
    };

    let redirect = {
      pathname: `/journey/analyse/${from}/${to}`,
      state: stateObject,
    };
    this.setState({ redirect: redirect });
  }

  private handleJourneyClicked(journey: Journey) {
    let from = this.props.match.params.from;
    let to = this.props.match.params.to;

    let stateObject: AppNavigationState = {
      searchContext: {
        fromStation: this.state.from,
        toStation: this.state.to,
        searchDate: this.state.searchDate,
      },
    };

    let redirect = {
      pathname: `/journey/${
        journey.id
      }/${from}/${to}/${APIUtils.dateToAPIString(journey.departure_datetime)}`,
      state: stateObject,
    };
    this.setState({ redirect: redirect });
  }

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect} />;

    let journeys = this.getJourneyTiles();
    return (
      <>
        <HeaderNavBar />
        <SearchResultHeader
          date={this.state.searchDate}
          from={this.state.from}
          to={this.state.to}
        />
        <a
          href="#top"
          title="Aller en haut de la page"
          id="top-link"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 6" fill="currentcolor">
            <path d="M12 6H0l6-6z"></path>
          </svg>
        </a>
        <div className="container">
          <div className="row search-res-tab">
            <button className="col-6 active">
              {this.props.t("next_trains_title")}
            </button>
            <button className="col-6" onClick={this.handleAnalyseClicked}>
              {this.props.t("analyse_my_trip_title")}
            </button>
          </div>
          {this.state.isLoadingJourneys && <LoadingSpinner />}
          {journeys}
        </div>
      </>
    );
  }
}

export default withTranslation()(SearchJourneyResultPage);
